<template>
	<el-container class="Wrapper">
		<el-container class="container">
			<div class="menum">
				<el-aside width="15%">
					<div class="category-menu">
						<h2 class="category-title">分类选择</h2>
						<el-radio-group v-model="selectedCategoryId" @change="filterMenu">
							<el-radio-button v-for="category in categories" :key="category.id" :label="category.id">{{
								category.name }}</el-radio-button>
						</el-radio-group>
					</div>
				</el-aside>
				<div class="menumanage">
					<h1 class="menu-title">一周采购菜单</h1>

					<!-- 使用el-button-group替代el-tabs -->
					<div class="tabs-wrapper">
						<el-button-group class="modern-tabs">
							<el-button v-for="tab in tabList" :key="tab.uniqueId"
								:class="{ 'is-active': activeTab === tab.uniqueId }" @click="handleTabClick(tab)"
								type="text">
								{{ tab.label }}
							</el-button>
						</el-button-group>
					</div>

					<div class="table-wrapper">
						<table class="styled-table" border="1">
							<thead class="table-header">
								<tr>
									<th class="sticky-date">日期</th>
									<th v-for="time in mealTimes" :key="time">{{ time }}</th>
								</tr>
							</thead>
							<tbody class="table-body">
								<template v-if="!selectedCategoryId">
									<tr>
										<td class="sticky-date table-cell"></td>
										<td class="table-cell no-data-cell" :colspan="mealTimes.length">请选择分类</td>
									</tr>
								</template>
								<template v-else>
									<template v-if="filteredMenu.length === 0">
										<tr>
											<td class="sticky-date table-cell" :colspan="mealTimes.length + 1">该分类暂无菜单
											</td>
										</tr>
									</template>
									<template v-else>
										<tr v-for="(day, index) in filteredMenu" :key="index" class="fade-in">
											<td class="sticky-date table-cell">{{ day.week }}</td>
											<td class="table-cell" v-for="time in mealTimes" :key="time"
												@dblclick="openEditMenuDialog(day, time)">{{ getMenuForTime(day, time)
												}}</td>
										</tr>
									</template>
								</template>
							</tbody>
						</table>
					</div>
				</div>
				<el-dialog v-model="editMenuDialogVisible" title="编辑菜单" width="70%">
					<el-form v-model="editMenu">
						<el-row :gutter="18" type="flex" style="flex-wrap: wrap;">

							<el-col :span="7">
								<el-form-item label="菜单日期">
									<el-select v-model="editMenu.week" placeholder="请选择日期">
										<el-option v-for="day in weekDays" :key="day" :label="day" :value="day">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="菜品类别">
									<el-select v-model="editMenu.categoriesId" placeholder="请选择类别">
										<el-option v-for="category in categories" :key="category.id"
											:label="category.name" :value="category.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="用餐时间">
									<el-select v-model="editMenu.time" placeholder="请选择用餐时间">
										<el-option label="早餐" value="早餐"></el-option>
										<el-option label="午餐" value="午餐"></el-option>
										<el-option label="晚餐" value="晚餐"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="套餐名">
									<el-select v-model="editMenu.meal" placeholder="请选择日期">
										<el-option v-for="day in tabList" :key="day" :label="day.name"
											:value="day.name">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="菜谱菜品">
									<el-table :data="editMenu.detailList" stripe @row-click="handleMenuRowClick"
										:row-style="rowStyle" @selection-change="handleSelectionChange">
										<el-table-column type="selection"></el-table-column>
										<el-table-column label="菜品名称" prop="dishName">
											<template #default="scope">
												<el-input v-model="scope.row.dishName" readonly
													@click="openChooseDishDialog(scope.$index)"></el-input>
											</template>
										</el-table-column>
									</el-table>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
					<el-row :gutter="12">
						<el-col :span="6">大份营养成分</el-col>
						<el-col :span="18">
							<div v-if="nutritionByPortion.bigIngredients">
								<span>碳水: {{ nutritionByPortion.bigIngredients.cho.toFixed(2) }}g</span>
								<span>能量: {{ nutritionByPortion.bigIngredients.energy.toFixed(2) }}kcal</span>
								<span>脂肪: {{ nutritionByPortion.bigIngredients.fat.toFixed(2) }}g</span>
								<span>钠: {{ nutritionByPortion.bigIngredients.na.toFixed(2) }}mg</span>
								<span>蛋白质: {{ nutritionByPortion.bigIngredients.protein.toFixed(2) }}g</span>
							</div>
						</el-col>
						<el-col :span="6">中份营养成分</el-col>
						<el-col :span="18">
							<div v-if="nutritionByPortion.middleIngredients">
								<span>碳水: {{ nutritionByPortion.middleIngredients.cho.toFixed(2) }}g</span>
								<span>能量: {{ nutritionByPortion.middleIngredients.energy.toFixed(2) }}kcal</span>
								<span>脂肪: {{ nutritionByPortion.middleIngredients.fat.toFixed(2) }}g</span>
								<span>钠: {{ nutritionByPortion.middleIngredients.na.toFixed(2) }}mg</span>
								<span>蛋白质: {{ nutritionByPortion.middleIngredients.protein.toFixed(2) }}g</span>
							</div>
						</el-col>
						<el-col :span="6">小份营养成分</el-col>
						<el-col :span="18">
							<div v-if="nutritionByPortion.smallIngredients">
								<span>碳水: {{ nutritionByPortion.smallIngredients.cho.toFixed(2) }}g</span>
								<span>能量: {{ nutritionByPortion.smallIngredients.energy.toFixed(2) }}kcal</span>
								<span>脂肪: {{ nutritionByPortion.smallIngredients.fat.toFixed(2) }}g</span>
								<span>钠: {{ nutritionByPortion.smallIngredients.na.toFixed(2) }}mg</span>
								<span>蛋白质: {{ nutritionByPortion.smallIngredients.protein.toFixed(2) }}g</span>
							</div>
						</el-col>
					</el-row>
					<template #footer>
						<el-button type="primary" @click="addRowToMenu">增加行</el-button>
						<el-button type="danger" @click="removeSelectedRows"
							:disabled="selectedRows.length === 0">删除选中行</el-button>
						<el-button @click="cancelEditMenuDialog">取消</el-button>
						<el-button type="primary" @click="saveEditedMenu">确定</el-button>
					</template>
				</el-dialog>
			</div>
		</el-container>
	</el-container>

	<!-- 选择菜品弹窗 -->
	<ChooseDish :modelValue="chooseDishDialogVisible" @confirm="confirmChooseDish"
		@update:modelValue="updateChooseDishVisible" 
		></ChooseDish>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import instance from '../network/storester.js';
import { ElMessage } from 'element-plus';
import ChooseDish from '../menumanagement/ChooseDish.vue'; // 引入选择菜品组件
import { method } from 'lodash';

const categories = ref([]);
const selectedCategoryId = ref(null);
const filteredMenu = ref([]);
const mealTimes = ref([]);
const editMenuDialogVisible = ref(false);
const currentSetMenu = ref('');
const meal = ref('')
const editMenu = ref({
	week: '',
	categoriesId: '',
	time: '',
	meal: '',
	detailList: []
});
const weekDays = ref(['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']);
const selectedMenuRowIndex = ref(-1);
const dialogWidth = ref('60%');
const dialogTop = ref('10vh');
const addDialogVisible = ref(false);
const newDish = ref({
	week: '',
	categoriesId: '',
	detailList: []
});
const selectedRowIndex = ref(-1);
const chooseDishDialogVisible = ref(false);
const currentChooseIndex = ref(-1);
const selectedRows = ref([]);
const nutritionByPortion = ref({
	bigIngredients: {
		cho: 0,
		energy: 0,
		fat: 0,
		na: 0,
		protein: 0,
	},
	middleIngredients: {
		cho: 0,
		energy: 0,
		fat: 0,
		na: 0,
		protein: 0,
	},
	smallIngredients: {
		cho: 0,
		energy: 0,
		fat: 0,
		na: 0,
		protein: 0,
	}
});
// 新增：记录勾选的食材行
const selectedIngredients = ref([]);
// 新增：Tab相关
const activeTab = ref('day');
// 新增：从后端获取的Tab列表
const tabList = ref([]);

// 获取营养成分数据的接口请求
const fetchNutrition = async (week, time) => {
	try {
		const response = await instance.get(`/api/dish/calFoodIngredientOne?week=${week}&time=${time}&categoriesId=${selectedCategoryId.value}&setMenu=${currentSetMenu.value}`);
		nutritionByPortion.value = response.data.data;
		console.log('fetchNutrition', response, nutritionByPortion.value);
	} catch (error) {
		ElMessage.error('获取营养成分数据失败');
	}
};
// 获取分类数据的接口请求
const fetchCategories = async (categoryId) => {
	try {
		const response = await instance.get('/api/categories/getMeanCategories');
		categories.value = response.data.data;
		// 默认选中第一个分类
		if (categories.value.length > 0) {
			selectedCategoryId.value = categories.value[0].id;
			// 获取第一个分类的菜单数据
			await fetchTabs(selectedCategoryId.value);
		}
	} catch (error) {
		ElMessage.error('获取分类数据失败');
		//console.error('获取分类数据失败:', error);
	}
};
// 新增：获取Tab页数据的接口请求
// 获取Tab页数据的接口请求
const fetchTabs = async (categoryId) => {
	try {
		const response = await instance.get(`/api/menuManager/getSetMenuByCategoriesId?categoriesId=${categoryId}`);
		console.log('获取Tab数据:', response);
		const tabNames = response.data.data || [];

		// 创建带有唯一ID的Tab对象
		tabList.value = tabNames.map((name, index) => ({
			name,
			uniqueId: `tab_${index}_${name}`, // 使用索引和名称创建唯一ID
			label: name // 使用名称作为显示标签
		}));
		console.log(tabList.value)
		// 如果有Tab数据，设置默认选中
		if (tabList.value.length > 0) {
			activeTab.value = tabList.value[0].uniqueId;
			currentSetMenu.value = tabList.value[0].name;
			fetchMenu(tabList.value[0].name, categoryId);
		}
	} catch (error) {
		ElMessage.error('获取Tab页数据失败');
		// 设置默认Tab

	}
};

// 根据分类ID获取菜单数据的接口请求
const fetchMenu = async (setMenu, categoryId) => {
	try {
		const response = await instance.get(`/api/menuManager/list?setMenu=${setMenu}&categoriesId=${categoryId}`);
		console.log(response)
		const total = response.data.data.total;
		if (total === 0) {
			filteredMenu.value = [];
			return;
		}

		const rawMenuData = response.data.data.dataList;
		console.log(rawMenuData)
		// 获取早中晚时间，过滤掉没有菜单数据的时间
		const allMealData = [];
		rawMenuData.forEach(day => {
			day.data.forEach(item => {
				if (item.data.length > 0) {
					allMealData.push(item);
				}
			});
		});
		const times = [...new Set(allMealData.map(item => item.time))];
		mealTimes.value = times;

		// 重新组织数据
		const organizedMenu = [];
		rawMenuData.forEach(day => {
			const dayMenu = {
				week: day.week
			};
			times.forEach(time => {
				const menuItem = day.data.find(item => item.time === time);
				if (menuItem && menuItem.data.length > 0) {
					const dishNames = menuItem.data.map(item => item.dishName).join('、');
					dayMenu[time] = dishNames;
				} else {
					dayMenu[time] = '';
				}
			});
			// 检查当天是否有菜单数据
			const hasMenuData = Object.values(dayMenu).some(value => value !== '' && typeof value === 'string');
			if (hasMenuData) {
				organizedMenu.push(dayMenu);
			}
		});
		filteredMenu.value = organizedMenu;
	} catch (error) {
		ElMessage.error('获取菜单数据失败');
		//console.error('获取菜单数据失败:', error);
	}
};

// 根据日期、用餐时间和分类ID获取菜单详情
const fetchMenuDetail = async (week, time) => {
	try {
		const response = await instance.get(`/api/menuManager/list?week=${week}&time=${time}&categoriesId=${selectedCategoryId.value}&setMenu=${currentSetMenu.value}`);
		const menuDetail = response.data.data.dataList.find(day => day.week === week);
		if (menuDetail) {
			const mealData = menuDetail.data.find(item => item.time === time);
			if (mealData) {
				editMenu.value = {
					week: week,
					categoriesId: selectedCategoryId.value,
					time: time,
					meal: currentSetMenu.value,
					detailList: mealData.data
				};
				//console.log(response.data.data.dataList)
				//console.log(editMenu.value)
			}
		}
	} catch (error) {
		ElMessage.error('获取菜单详情失败');
		//console.error('获取菜单详情失败:', error);
	}
};

onMounted(async () => {
	// 并行获取分类和Tab数据
	await Promise.all([fetchCategories()]);
});

const filterMenu = async () => {
	if (selectedCategoryId.value) {
		await fetchMenu(currentSetMenu.value, selectedCategoryId.value);
	} else {
		filteredMenu.value = [];
	}
};

const getMenuForTime = (day, time) => {
	return day[time] || '';
};

const openEditMenuDialog = async (day, time) => {
	await fetchMenuDetail(day.week, time);
	await fetchNutrition(day.week, time);
	editMenuDialogVisible.value = true;
};

const cancelEditMenuDialog = () => {
	editMenuDialogVisible.value = false;
	selectedMenuRowIndex.value = -1;
	selectedRows.value = [];
};

const saveEditedMenu = async () => {
	//console.log(editMenu.value.detailList)
	const dataToSend = editMenu.value.detailList.map(item => ({
		categoriesId: editMenu.value.categoriesId,
		dishId: item.dishId || 0,
		dishName: item.dishName,
		id: item.id || 0,
		isDeleted: item.isDeleted || 0,
		time: editMenu.value.time,
		week: editMenu.value.week,
		setMenu: editMenu.value.meal
	}));

	try {
		const response = await instance.post('/api/menuManager/saveBatch', dataToSend);
		if (response.data.state === 20000) {
			ElMessage.success('保存成功');
			editMenuDialogVisible.value = false;
			filterMenu();
		} else {
			ElMessage.error('保存失败：' + response.data.msg);
		}
	} catch (error) {
		ElMessage.error('保存失败，请稍后重试');
		//console.error('保存失败:', error);
	}
};

const handleMenuRowClick = (row, event, column) => {
	const index = editMenu.value.detailList.indexOf(row);
	selectedMenuRowIndex.value = index;
};

const rowStyle = ({ row, rowIndex }) => {
	if (rowIndex === selectedMenuRowIndex.value || rowIndex === selectedRowIndex.value) {
		return { background: '#e5f6ff' };
	}
	return {};
};

const handleSelectionChange = (val) => {
	selectedRows.value = val;
};

const removeSelectedRows = async () => {
	if (selectedRows.value.length > 0) {
		for (const row of selectedRows.value) {
			const itemId = row.id;
			if (itemId) {
				try {
					await instance.get(`/api/menuManager/deleted/${itemId}`);
					ElMessage.success('删除成功');
				} catch (error) {
					ElMessage.error('删除失败，请稍后重试');
					//console.error('删除失败:', error);
					return;
				}
			}
		}
		// 从列表中移除选中的行
		editMenu.value.detailList = editMenu.value.detailList.filter(item => !selectedRows.value.includes(item));
		selectedRows.value = [];
	}
};

const addRowToMenu = () => {
	editMenu.value.detailList.push({
		dishName: '',
		// 可以根据实际情况添加其他默认字段
	});
};

const openChooseDishDialog = (index) => {
	currentChooseIndex.value = index;
	chooseDishDialogVisible.value = true;
};

const confirmChooseDish = (dish) => {
	//console.log(dish);
	if (currentChooseIndex.value >= 0 && currentChooseIndex.value < editMenu.value.detailList.length) {
		const existingItem = editMenu.value.detailList[currentChooseIndex.value];
		editMenu.value.detailList[currentChooseIndex.value] = {
			...existingItem,
			dishId: dish.id,
			dishName: dish.dishName || existingItem.dishName
		};
	}
	chooseDishDialogVisible.value = false;
};
const updateChooseDishVisible = (visible) => {
	chooseDishDialogVisible.value = visible;
};

// 新增：Tab点击事件处理
const handleTabClick = async (tab) => {
	console.log('Tab clicked:', tab.name);

	// 如果点击的是当前已选中的Tab，不重复请求
	if (activeTab.value === tab.uniqueId) {
		return;
	}

	// 更新选中状态
	activeTab.value = tab.uniqueId;
	currentSetMenu.value = tab.name;
	// 请求新的菜单数据
	if (selectedCategoryId.value) {
		await fetchMenu(tab.name, selectedCategoryId.value);
	}
};
</script>

<style scoped>
/* 全局样式，设置字体和背景颜色 */
html {
	font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
	background: linear-gradient(135deg, #e0f7fa, #f1f8e9);
}

.menum {
	display: flex;
	margin-top: 7vh;
	left: -4vw;
	pointer-events: none; /* 让该元素不响应鼠标事件 */
}

.menum h1.menu-title {
	text-align: center;
	font-size: 32px;
	font-weight: 800;
	color: white;
	margin-bottom: 20px;
	position: sticky;
	top: 0;
	background: linear-gradient(90deg, #2196f3, #3498db);
	z-index: 2;
	padding: 20px 0;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
	border-radius: 12px;
	text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.menum h2.category-title {
	text-align: center;
	font-size: 24px;
	font-weight: 600;
	color: #2196f3;
	margin-bottom: 20px;
}

.menum table.styled-table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 20px;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
	background-color: white;
	table-layout: fixed;
}

.menum thead.table-header {
	background: linear-gradient(90deg, #2196f3, #3498db);
	color: white;
	position: sticky;
	top: 0;
	/* 固定在顶部 */
	z-index: 1;
	/* 确保表头在内容之上 */
}

.menum th,
.menum td.table-cell {
	padding: 18px;
	text-align: center;
	border-bottom: 1px solid #e0e0e0;
	transition: background-color 0.3s ease;
	min-width: 150px;
	line-height: 1.5;
	word-wrap: break-word;
}

.menum th:nth-child(1),
.menum td.sticky-date {
	width: 10%;
}

.menum th:nth-child(n + 2),
.menum td.table-cell:not(.sticky-date) {
	width: calc(90% / 3);
}

.menum tbody.table-body tr {
	opacity: 0;
	animation: fadeIn 0.5s ease-in-out forwards;
	animation-delay: calc(var(--index) * 0.1s);
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(20px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.menum tbody.table-body tr:hover {
	background-color: #e1f5fe;
	transform: scale(1.01);
	transition: all 0.3s ease;
}

.menum .Wrapper {
	display: flex;
	min-height: 100vh;
}

.menum .container {
	width: 100%;
}

.menum .menumanage {
	/* margin-top: 7vh; */
	width: 60%;
	height: 85vh;
	position: relative;
	padding: 30px;
	background-color: white;
	border-radius: 12px;
	box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
	left: 2%;
}

.menum .table-wrapper {
	max-height: calc(100% - 150px);
	/* 调整高度以适应Tab标签 */
	overflow: auto;
	scrollbar-width: thin;
	scrollbar-color: #2196f3 #f4f7fa;
}

/* 自定义滚动条样式（适用于 Chrome、Safari 和 Edge） */
.menum .table-wrapper::-webkit-scrollbar {
	width: 10px;
}

.menum .table-wrapper::-webkit-scrollbar-track {
	background: #f4f7fa;
	border-radius: 5px;
}

.menum .table-wrapper::-webkit-scrollbar-thumb {
	background-color: #2196f3;
	border-radius: 5px;
}

.menum .sticky-date {
	position: sticky;
	left: 0;
	background-color: white;
	z-index: 1;
	box-shadow: 4px 0 8px rgba(0, 0, 0, 0.1);
}

.menum .table-header .sticky-date {
	background: linear-gradient(90deg, #2196f3, #3498db);
}

.menum .category-menu {
	background-color: white;
	padding: 20px;
	border-radius: 12px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	/* 添加阴影，让分类选择区域更明显 */
	top: 0;
	margin-left: 0;
	/* 确保分类选择区域紧靠左边缘 */
	height: 100%;
	overflow-y: auto;
	overflow-y: overlay;
	/* 让滚动条在需要时才显示 */
}

.menum .el-radio-group {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.menum .el-radio-button__inner {
	border: none;
	background-color: #e1f5fe;
	color: #2196f3;
	transition: background-color 0.3s ease;
	width: 100%;
}

.menum>>>.el-radio-button__inner {
	width: 100% !important;
}

.menum .el-radio-button__inner:hover {
	background-color: #b3e5fc;
}

.menum .el-radio-button__original:checked+.el-radio-button__inner {
	background-color: #2196f3;
	color: white;
}

.el-radio-button:first-child .el-radio-button__inner {
	width: 100%;
}

.menum .no-category {
	text-align: center;
	font-size: 18px;
	color: #999;
	margin-top: 50px;
}

.menum .no-data-cell {
	color: #999;
}

.menum .el-radio-button {
	width: 100%;
	    border: 1px solid #ccc
}

/* 响应式设计 */
@media (max-width: 768px) {
	.Wrapper {
		flex-direction: column;
	}

	.el-aside {
		width: 100%;
	}

	.menumanage {
		width: 95vw;
		margin-left: -2.5vw;
	}

	th,
	td.table-cell {
		min-width: auto;
		padding: 12px;
	}
}

.menum>>>.el-dialog {
	width: 70%;
}

/* Tab标签容器样式 */
.tabs-wrapper {
	overflow-x: auto;
	overflow-y: hidden;
	scrollbar-width: thin;
	scrollbar-color: #2196f3 #f4f7fa;
	margin-bottom: 15px;
	white-space: nowrap;
	/* 确保标签不换行 */
}

.tabs-wrapper::-webkit-scrollbar {
	height: 6px;
}

.tabs-wrapper::-webkit-scrollbar-track {
	background: #f4f7fa;
	border-radius: 3px;
}

.tabs-wrapper::-webkit-scrollbar-thumb {
	background-color: #2196f3;
	border-radius: 3px;
}

/* 自定义Tab按钮样式 */
.modern-tabs {
	display: flex;
	gap: 10px;
	overflow-x: auto;
	white-space: nowrap;
	padding-bottom: 8px;
}

.modern-tabs::-webkit-scrollbar {
	height: 6px;
}

.modern-tabs::-webkit-scrollbar-track {
	background: #f4f7fa;
	border-radius: 3px;
}

.modern-tabs::-webkit-scrollbar-thumb {
	background-color: #2196f3;
	border-radius: 3px;
}

.modern-tabs .el-button {
	flex: 0 0 auto;
	padding: 8px 16px;
	border-radius: 8px;
	border: 1px solid #dcdfe6;
	background-color: white;
	color: #606266;
	font-weight: 500;
	transition: all 0.3s ease;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.modern-tabs .el-button:hover {
	color: #2196f3;
	border-color: #2196f3;
	transform: translateY(-1px);
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.modern-tabs .el-button.is-active {
	color: #2196f3;
	border-color: #2196f3;
	background-color: #e6f4ff;
	font-weight: 600;
	transform: translateY(0);
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	animation: pulse 2s infinite;
	/* 添加这一行，确保阴影也有圆角 */
	overflow: hidden;
}

/* 修改动画定义，添加border-radius属性 */
@keyframes pulse {
	0% {
		box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.4);
		border-radius: 8px;
		/* 与按钮的border-radius保持一致 */
	}

	70% {
		box-shadow: 0 0 0 6px rgba(33, 150, 243, 0);
		border-radius: 8px;
	}

	100% {
		box-shadow: 0 0 0 0 rgba(33, 150, 243, 0);
		border-radius: 8px;
	}
}

</style>